export const Report = {
  ReportCode: {
    BOOKEDTIMEBYRESOURCE_REPORTCODE: 'BTRR',
    BOOKEDTIMEBYENGAGEMENT_REPORTCODE: 'BTRE',
    AVAILABILITYBYFORECASTEDHOURS_REPORTCODE: 'AFHR',
    AUDITTRAIL_REPORTCODE: 'ATR',
    ADOPTION_REPORTCODE: 'ADR'
  },
  ReportFileName: {
    BOOKEDTIMEBYRESOURCE_FILENAME: 'BookTimeByResource',
    BOOKEDTIMEBYENGAGEMENT_FILENAME: 'BookedTimeByEngagement',
    AVAILABILITYBYFORECASTEDHOURS_FILENAME: 'AvailabilityByForecastedHours',
    AUDITTRAIL_FILENAME: 'AuditTrailReport',
    ADOPTION_FILENAME: 'AdoptionReport'
  }
}